import React from 'react';
import {
  LayoutDashboard,
  Activity,
  Users,
  Upload,
  CheckSquare,
  BarChart2,
  Home,
  X,
} from 'lucide-react';
import SidebarBrand from './SidebarBrand';
import SidebarNavLink from './SidebarNavLink';
import SidebarAccountMenu from './SidebarAccountMenu';

const navItems = [
  { to: '/app/dashboard', label: 'Overview', icon: LayoutDashboard },
  { to: '/app/employees', label: 'People', icon: Users },
  { to: '/app/risk', label: 'Risk Map', icon: Activity },
  { to: '/app/actions', label: 'Actions', icon: CheckSquare },
  { to: '/app/reports', label: 'Reports', icon: BarChart2 },
  { to: '/app/imports', label: 'Imports', icon: Upload },
];

export default function SidebarNavigation({ user, onClose, onNavClick }) {
  return (
    <div className="app-sidebar__inner flex flex-col h-full">
      <div className="app-sidebar__header shrink-0">
        <button
          type="button"
          onClick={onClose}
          className="lg:hidden app-icon-btn app-sidebar__close-btn"
          style={{ width: 32, height: 32 }}
          aria-label="Close menu"
        >
          <X className="w-4 h-4" />
        </button>
        <SidebarBrand />
      </div>

      <nav className="app-sidebar__nav flex-1 flex flex-col gap-0.5">
        {navItems.map(({ to, label, icon }) => (
          <SidebarNavLink
            key={to}
            to={to}
            label={label}
            icon={icon}
            end={to === '/app/dashboard'}
            onClick={onNavClick}
          />
        ))}
      </nav>

      <div className="app-sidebar__divider app-sidebar__divider--footer" aria-hidden="true" />

      <div className="app-sidebar__footer shrink-0">
        <SidebarNavLink
          to="/"
          label="Homepage"
          icon={Home}
          onClick={onNavClick}
        />

        {user && <SidebarAccountMenu onNavClick={onNavClick} />}
      </div>
    </div>
  );
}
